var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "m-items" },
    [
      _c(
        "b-modal",
        {
          attrs: {
            id: "m-items",
            centered: "",
            "hide-footer": "",
            "hide-header": "",
          },
          model: {
            value: _vm.localActive,
            callback: function ($$v) {
              _vm.localActive = $$v
            },
            expression: "localActive",
          },
        },
        [
          _c(
            "svg",
            {
              staticClass: "m-items-close",
              attrs: {
                width: "15",
                height: "16",
                viewBox: "0 0 15 16",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
              },
              on: { click: _vm.closeModal },
            },
            [
              _c("path", {
                attrs: {
                  d: "M10.6045 11.5377C10.2154 11.9267 9.58272 11.9247 9.19126 11.5333L3.53712 5.88051C3.14565 5.48904 3.14367 4.85633 3.5327 4.4673C3.92172 4.07828 4.55443 4.08026 4.9459 4.47173L10.6 10.1245C10.9915 10.5159 10.9935 11.1486 10.6045 11.5377Z",
                  fill: "#8E9CBB",
                },
              }),
              _c("path", {
                attrs: {
                  d: "M10.6127 4.47053C10.2212 4.07907 9.58849 4.07709 9.19947 4.46611L3.53718 10.1284C3.14816 10.5174 3.15014 11.1501 3.54161 11.5416C3.93307 11.9331 4.56579 11.9351 4.95481 11.546L10.6171 5.88374C11.0061 5.49471 11.0041 4.862 10.6127 4.47053Z",
                  fill: "#8E9CBB",
                },
              }),
            ]
          ),
          _c("div", { staticClass: "m-items-title" }, [
            _vm._v(_vm._s(_vm.modalTitle)),
          ]),
          _vm.modalDescription
            ? _c(
                "div",
                {
                  staticClass: "m-items-description",
                  domProps: { innerHTML: _vm._s(_vm.modalDescription) },
                },
                [
                  _vm._v(" " + _vm._s(_vm.modalDescription) + " "),
                  _c("span", { staticClass: "m-items-description-bold" }, [
                    _vm._v(_vm._s(_vm.modalDescriptionItem)),
                  ]),
                ]
              )
            : _vm._e(),
          _vm.createCategory && !_vm.modalConfirm
            ? _c("c-input", {
                staticClass: "m-items-select",
                attrs: {
                  type: "select",
                  searchable: true,
                  placeholder: "Выберите группу",
                  items: _vm.localGroups,
                },
                model: {
                  value: _vm.currentGroup,
                  callback: function ($$v) {
                    _vm.currentGroup = $$v
                  },
                  expression: "currentGroup",
                },
              })
            : _vm._e(),
          !_vm.modalConfirm
            ? _c("c-input", {
                staticClass: "m-items-input",
                attrs: {
                  "max-length": _vm.inputMaxLength,
                  "input-text-condition": _vm.requiredMessage,
                  placeholder: _vm.inputPlaceholder,
                  type: "text",
                },
                model: {
                  value: _vm.itemName,
                  callback: function ($$v) {
                    _vm.itemName = $$v
                  },
                  expression: "itemName",
                },
              })
            : _vm._e(),
          _c(
            "div",
            { staticClass: "m-items-buttons" },
            [
              _c("c-button", {
                staticClass: "m-items-buttons-cancel",
                attrs: { color: "white", label: "Отменить" },
                on: { click: _vm.closeModal },
              }),
              !_vm.modalConfirm
                ? _c("c-button", {
                    attrs: { color: "primary", label: "Применить" },
                    on: { click: _vm.createItem },
                  })
                : _vm._e(),
              _vm.modalConfirm
                ? _c("c-button", {
                    attrs: {
                      color: "secondary",
                      label: _vm.confirmButtonLabel
                        ? _vm.confirmButtonLabel
                        : "Удалить",
                    },
                    on: { click: _vm.removeItemRequest },
                  })
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }